module.exports = __webpack_public_path__ + "img/wlwbyznkzq2.a4e86f67.jpg";